export const SET_CUSTOM_PLANS = 'SET_CUSTOM_PLANS';
export const CLEAR_CUSTOM_PLANS = 'CLEAR_CUSTOM_PLANS';

const initialState = [];

export function setCustomPlans(arr) {
  return {
    type    : SET_CUSTOM_PLANS,
    payload : arr
  };
}

export function clearCustomPlans() {
  return {
    type    : CLEAR_CUSTOM_PLANS
  };
}

export default function customPlansReducer(state = initialState, action) {
  if (action.type === SET_CUSTOM_PLANS) {
    return action.payload;
  }
  if (action.type === CLEAR_CUSTOM_PLANS) {
    return initialState;
  }
  return state;
}
